export default [
    {
      // path: 'relatorios/ganhadores-admin-print',
      path: '',
      name: 'ganhadores-admin-print',
      component: () => import('./index'),
      meta: {
        visible: true,
        title: 'Ganhadores',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'Relatórios', link: 'relatorios' },
          { name: 'Ganhadores Admin Print'},
        ]
      }
    }
  ]